import DateFormat from "../utils/DateFormat";
import { fromWorkDaysDTO } from "./workDay";

export const fromWorkRecordDTO = ({
    id,
    name,
    institute,
    workDays,
}) => ({
    id,
    name,
    institute,
    workDays: fromWorkDaysDTO(workDays),
});

export const fromWorkRecordsDTO = (workRecords) => workRecords.map(wr => fromWorkRecordDTO(wr));

export const toWorkRecordSubmittedStatusDTO = ({
    userIds,
    start,
    end,
}) => ({
    users: userIds,
    start: start ? DateFormat.formatISOStringWithTimeZone(start).split('T')[0] : null,
    end: end ? DateFormat.formatISOStringWithTimeZone(end).split('T')[0] : null,
});

export const fromWorkRecordSubmittedStatusDTO = ({
    user,
    month,
    submitted,
}) => ({
    user: {
        id: user.id,
        name: user.name,
    },
    month: new Date(month),
    submitted,
});

export const fromWorkRecordSubmittedStatusesDTO = (statuses) => statuses.map(wrss => fromWorkRecordSubmittedStatusDTO(wrss));

export const toAllWorkRecordsDTO = ({
    userIds,
    start,
    end,
}) => ({
    users: userIds,
    start: start ? DateFormat.formatISOStringWithTimeZone(start).split('T')[0] : null,
    end: end ? DateFormat.formatISOStringWithTimeZone(end).split('T')[0] : null,
});